<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sTicket">Ticket </label>
                  <b-input id="sTicket" type="text" placeholder="" v-model.trim="sTicket"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sRound">Round Number </label>
                  <b-input id="sRound" type="text" placeholder="" v-model.trim="sRound"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sDrawNumber">Draw Number </label>
                  <b-input id="sDrawNumber" type="text" placeholder="" v-model.trim="sDrawNumber"></b-input>
                </b-col>
                <b-col sm="3">
                  <label for="sResult">Result</label>
                  <b-form-select id="sResult" :plain="false" v-model="sResult">
                    <option :value="null">Please select</option>
                    <option v-for="s in resultOption" :key="`Result-${s.id}`" :value="s.id">{{ s.label }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label for="sStatus">Status</label>
                  <b-form-select id="sStatus" :plain="false" v-model="sStatus">
                    <option :value="null">Please select</option>
                    <option v-for="s in statusOption" :key="`Status-${s.id}`" :value="s.id">{{ s.label }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">Add Time (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">Add Time (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Tickets</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(RoundNumber)="data">
                  <b-badge v-if="!data.item.RoundNumber" variant="success">In Progress</b-badge>
                  <span v-else>#{{ data.item.RoundNumber }}</span>
                </template>
                <template v-slot:cell(DrawCard)="data">
                  <b-badge v-if="data.item.DrawCard" variant="success">{{ data.item.DrawCard }}</b-badge>
                  <b-badge v-else variant="danger">Not Decided Yet</b-badge>
                </template>
                <template v-slot:cell(Result)="data">
                  <b-badge v-if="data.item.Result === 1" variant="success">Win</b-badge>
                  <b-badge v-else-if="data.item.Result === 0" variant="danger">Loose</b-badge>
                  <b-badge v-else variant="warning">Not Decided Yet</b-badge>
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge v-if="data.item.Status === 0" variant="warning">Created</b-badge>
                  <b-badge v-else-if="data.item.Status === 1" variant="info">Draw</b-badge>
                  <b-badge v-else-if="data.item.Status === 2" variant="success">Redeem</b-badge>
                  <b-badge v-else-if="data.item.Status === 3" variant="danger">Void</b-badge>
                </template>
                <template v-slot:cell(Action)="data">
                  <template v-if="data.item.RoundNumber && data.item.Status === 0">
                    <b-btn class="btn-sm" variant="warning" @click="settleTicket(data.item)">Settle Ticket</b-btn>
                    <b-btn class="btn-sm" variant="danger" @click="voidTicket(data.item)">Void Ticket</b-btn>
                  </template>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
const moment = require('moment-timezone')

export default {
  name: 'Lottery-ticket-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'RoundNumber', label: 'Round No'},
        {key: 'DrawNumber', label: 'Draw Number'},
        {key: 'Ticket', label: 'Ticket'},
        {key: 'Username', label: 'Username'},
        {key: 'Name', label: 'Bet Card'},
        {key: 'DrawCard', label: 'Win Card'},
        {key: 'Result', label: 'Result'},
        {key: 'BetAmount', label: 'Bet Amount'},
        {key: 'WinAmount', label: 'Win Amount'},
        {key: 'Status', label: 'Status'},
        {key: 'BetTime', label: 'Bet Time'},
        {key: 'DrawTime', label: 'Draw Time'},
        {key: 'ModifyOperator', label: 'Modified By'},
        {key: 'UpdateTime', label: 'Modified On'},
        {key: 'Action', label: 'Action'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      resultOption: [
        {id: '1', label: 'Win'},
        {id: '0', label: 'No Win'}
      ],
      statusOption: [
        {id: '0', label: 'Created'},
        {id: '1', label: 'Draw'},
        {id: '2', label: 'Redeem'},
        {id: '3', label: 'Void'}
      ],
      sUsername: '',
      sTicket: '',
      sRound: '',
      sDrawNumber: '',
      sResult: null,
      sStatus: null,
      sStartTime: moment().subtract(1, 'days').tz('Asia/Taipei').format('YYYY-MM-DD'),
      sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD')
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `ticket=${this.sTicket}&round=${this.sRound}&drawNumber=${this.sDrawNumber}&username=${this.sUsername}&result=${this.sResult || ''}&status=${this.sStatus || ''}&startTime=${this.sStartTime}&endTime=${this.sEndTime}&size=${this.perPage}&page=${this.currentPage}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/lottery/ticket/search?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.tickets
        this.rowCount = data.rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async settleTicket (item) {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/lottery/ticket/settle', {
          drawNumber: item.DrawNumber,
          ticket: item.Ticket
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Settled Successfully')
        this.search()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async voidTicket (item) {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/lottery/ticket/void', {
          drawNumber: item.DrawNumber,
          ticket: item.Ticket
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Void Successfully')
        this.search()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    checkAccessPrivilege (module, title = false) {
      return true
      // if (!module) return true
      // if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      // return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/lottery/tickets/TicketsTable.vue